export const listerPagePaths: string[] = [
  'accounts',
  'agreements',
  'client-parents',
  'clients',
  'creditors',
  'debtors',
  'estates',
  'headleases',
  'landlords',
  'leases',
  'main',
  'managers',
  'properties',
  'suppliers',
  'tenant-parents',
  'tenants',
  'units',
  'vacants',
];

/**
 * @remarks
 *
 * `toLowerCase` conversion here should not be done because
 * the managers dashboard uses the manager code e.g. DTT in
 * the URL, causing mismatch when comparing URLs and entity
 * keys which could cause incorrect urls in the overview tiles
 * or entity keys not to match causing unnecessary re-queries
 * of overview counts.
 *
 * @param url the dashboard or lister url
 */
export function removeListerPageRouteFromUrl(url: string): string {
  const pattern = '/(' + listerPagePaths.join('|') + ')$';
  const re = new RegExp(pattern);
  return url.replace(re, '');
}
